'use client';

import React from 'react';
import CurrencyExchangeCalculator from '@/components/(postTypes)/symbols/single/coin/CurrencyExchangeCalculator';
import { CoinProps } from '@/types/coins';

interface SingleCoinExchangeProps {
    price: number;
    initialCoin?: CoinProps;
}

const SingleCoinExchange: React.FC<SingleCoinExchangeProps> = ({ price, initialCoin }) => {
    return <CurrencyExchangeCalculator selectedCurrency={initialCoin} usdtToToman={price} />;
};

export default SingleCoinExchange;
